export enum JSBRIDGE_HANDLER_NAME {
  CHECK_SID = 'HS:JSBRIDGE:CHECK:SID', // IOS调用获取SID
  CONFIG = 'HS:JSBRIDGE:CONFIG', // 获取配置
  CLOSE = 'HS:JSBRIDGE:CLOSE', // 关闭
  CLOSE_WAIT = 'HS:JSBRIDGE:CLOSE:WAIT', // 通知APP， H5来控制关闭
  ACTION_BUTTONS = 'HS:JSBRIDGE:ACTION:BUTTONS', // 设置 右上角操作按钮组
  ACTION_BUTTONS_CALLBACK = 'HS:JSBRIDGE:ACTION_BUTTONS:CALLBACK', // 设置 -自定义按钮 右上角操作按钮组 - 回调

  TO_NATIVE = 'HS:JSBRIDGE:TO:NATIVE', // H5 主动通知原生页面
  SHARE_CALLBACK = 'HS:JSBRIDGE:SHARE:CALLBACK', // H5 分享成功之后，触发回调功能
  STOCK_SEARCH = 'HS:JSBRIDGE:STOCK:SEARCH', // 搜索股票, 在转股的页面使用

  REFRESH_COMMENTS = 'HS:JSBRIDGE:REFRESHCOMMENTS', // 监听原生通知H5刷新评论
  REFRESH_JUMP = 'HS:JSBRIDGE:REFRESHJUMP', // 监听原生通知H5滚到评论或者页面顶部
  SPEECH_CALLBACK = 'HS:JSBRIDGE:SPEECH:CALLBACK', // app点击语音播放/暂停

  SZCA_SCAN_IDCARD = 'HS:JSBRIDGE:SZCA:SCAN:IDCARD', // 调用 深圳CA 扫描身份证
  SZCA_SCAN_LIVEDETECT = 'HS:JSBRIDGE:SZCA:SCAN:LIVEDETECT', // 调用 深圳CA 活体检测

  TITLE_BAR_USERINFO = 'HS:JSBRIDGE:TITLEBAR:USERINFO', // 滚动修改顶部标题
  REAL_TRADE_CALLBACK = 'HS:JSBRIDGE:REAL_TRADE:CALLBACK', // 点击右上角实盘开启和关闭的回调

  APPLY_PAY = 'HS:JSBRIDGE:APPLE_PAY', // 苹果内购
  TERMINATE = 'HS:JSBRIDGE:TERMINATE', // 美股行情聲明，MAC独有的关闭方法

  GDCA_SCAN_LIVEDETECT = 'HS:JSBRIDGE:GDCA:SCAN:LIVEDETECT', // 调用 广东CA 视频

  WEBVIEW_CONFIG = 'HS:JSBRIDGE:WEBVIEW:CONFIG', // 1. 顶部导航栏显示/隐藏,设置背景色，标题等, 2.底部适配高度显示/隐藏
  TOPIC_EDITOR_CALLBACK = 'HS:JSBRIDGE:TOPIC_EDITOR:CALLBACK', // 注册话题编辑器回调事件--接收到response代表发帖成功

  THIRD_CONFIG = 'HS:JSBRIDGE:THIRD:CONFIG', // 第三方（如阿里云OCR）

  OPERATR_CONFIG = 'HS:JSBRIDGE:OPERATR:CONFIG', // 用于H5调用原生设备方法，如拍照，相册等等

  // 沙特专属
  CUSTOMER_SERVICE = 'HS:JSBRIDGE:CUSTOMER:ALERT', // 沙特展业帮助中心 - 客服弹窗
  IMAGE_PREVIEW = 'HS:JSBRIDGE:IMAGE:PREVIEW', // 沙特图片预览
  IMAGE_PREVIEW_CALLBACK = 'HS:JSBRIDGE:IMAGE:PREVIEW:CALLBACK', // 沙特图片预览用户操作回调

  QUOTE_PRODUCT = 'HS:JSBRIDGE:QUOTE:PRODUCT', // 沙特展业行情订阅商品列表
  NETWORK_STATUS = 'HS:JSBRIDGE:NETWORK:STATUS', // 沙特网络状态变化 回调
  APP_CALL = 'HS:JSBRIDGE:APP:CALL:CALLBACK', // 沙特通用的 App 主动呼叫事件
}

/**
 * 调用函数名
 */
export const JSBRIDGE_HANDLER_NAME_CALL = {
  CONFIG: JSBRIDGE_HANDLER_NAME.CONFIG,
  CLOSE: JSBRIDGE_HANDLER_NAME.CLOSE,
  CLOSE_WAIT: JSBRIDGE_HANDLER_NAME.CLOSE_WAIT,
  ACTION_BUTTONS: JSBRIDGE_HANDLER_NAME.ACTION_BUTTONS,
  TO_NATIVE: JSBRIDGE_HANDLER_NAME.TO_NATIVE,
  SHARE_CALLBACK: JSBRIDGE_HANDLER_NAME.SHARE_CALLBACK,
  STOCK_SEARCH: JSBRIDGE_HANDLER_NAME.STOCK_SEARCH,

  SZCA_SCAN_IDCARD: JSBRIDGE_HANDLER_NAME.SZCA_SCAN_IDCARD,
  SZCA_SCAN_LIVEDETECT: JSBRIDGE_HANDLER_NAME.SZCA_SCAN_LIVEDETECT,

  CHECK_SID: JSBRIDGE_HANDLER_NAME.CHECK_SID,
  TERMINATE: JSBRIDGE_HANDLER_NAME.TERMINATE,

  TITLE_BAR_USERINFO: JSBRIDGE_HANDLER_NAME.TITLE_BAR_USERINFO,
  APPLY_PAY: JSBRIDGE_HANDLER_NAME.APPLY_PAY,

  GDCA_SCAN_LIVEDETECT: JSBRIDGE_HANDLER_NAME.GDCA_SCAN_LIVEDETECT,

  WEBVIEW_CONFIG: JSBRIDGE_HANDLER_NAME.WEBVIEW_CONFIG,

  THIRD_CONFIG: JSBRIDGE_HANDLER_NAME.THIRD_CONFIG,

  CUSTOMER_SERVICE: JSBRIDGE_HANDLER_NAME.CUSTOMER_SERVICE,
  IMAGE_PREVIEW: JSBRIDGE_HANDLER_NAME.IMAGE_PREVIEW,
  QUOTE_PRODUCT: JSBRIDGE_HANDLER_NAME.QUOTE_PRODUCT,

  OPERATR_CONFIG: JSBRIDGE_HANDLER_NAME.OPERATR_CONFIG,
};

/**
 * 注册函数名
 */
export const JSBRIDGE_HANDLER_NAME_REGISTER = {
  CLOSE: JSBRIDGE_HANDLER_NAME.CLOSE,
  SHARE_CALLBACK: JSBRIDGE_HANDLER_NAME.SHARE_CALLBACK,
  REFRESH_COMMENTS: JSBRIDGE_HANDLER_NAME.REFRESH_COMMENTS,
  REFRESH_JUMP: JSBRIDGE_HANDLER_NAME.REFRESH_JUMP,
  SPEECH_CALLBACK: JSBRIDGE_HANDLER_NAME.SPEECH_CALLBACK,
  ACTION_BUTTONS: JSBRIDGE_HANDLER_NAME.ACTION_BUTTONS,
  ACTION_BUTTONS_CALLBACK: JSBRIDGE_HANDLER_NAME.ACTION_BUTTONS_CALLBACK,

  SZCA_SCAN_IDCARD: JSBRIDGE_HANDLER_NAME.SZCA_SCAN_IDCARD,
  SZCA_SCAN_LIVEDETECT: JSBRIDGE_HANDLER_NAME.SZCA_SCAN_LIVEDETECT,

  TITLE_BAR_USERINFO: JSBRIDGE_HANDLER_NAME.TITLE_BAR_USERINFO,
  REAL_TRADE_CALLBACK: JSBRIDGE_HANDLER_NAME.REAL_TRADE_CALLBACK,
  APPLY_PAY: JSBRIDGE_HANDLER_NAME.APPLY_PAY,

  GDCA_SCAN_LIVEDETECT: JSBRIDGE_HANDLER_NAME.GDCA_SCAN_LIVEDETECT,

  WEBVIEW_CONFIG: JSBRIDGE_HANDLER_NAME.WEBVIEW_CONFIG,
  TOPIC_EDITOR_CALLBACK: JSBRIDGE_HANDLER_NAME.TOPIC_EDITOR_CALLBACK,

  TO_NATIVE: JSBRIDGE_HANDLER_NAME.TO_NATIVE,

  THIRD_CONFIG: JSBRIDGE_HANDLER_NAME.THIRD_CONFIG,

  CUSTOMER_SERVICE: JSBRIDGE_HANDLER_NAME.CUSTOMER_SERVICE,

  // OPERATR_CONFIG: JSBRIDGE_HANDLER_NAME.OPERATR_CONFIG,

  NETWORK_STATUS: JSBRIDGE_HANDLER_NAME.NETWORK_STATUS,
  APP_CALL: JSBRIDGE_HANDLER_NAME.APP_CALL,
  IMAGE_PREVIEW_CALLBACK: JSBRIDGE_HANDLER_NAME.IMAGE_PREVIEW_CALLBACK,
};

export enum NativeType {
  LOGIN = 'LOGIN',
  IPO = 'IPO',
  STOCK_DETAIL = 'STOCK_DETAIL',
}

export enum RedirectType {
  OPEN_COMMON_URL = 1, // 通用页面跳转
  NEWS_DETAIL = 2, // 资讯详情页
  STOCK_DETAIL = 3, // 股票详情页
  TOPIC_DETAIL = 32, // 话题详情页
  USER_HOME = 42, // 用户主页
  STOCK_DETAIL_2 = 43, // 股票详情页2
  COMMENT = 45, // 回复评论
  CIRCLE_DETAIL = 48, // 圈子详情页
  ZAN = 57, // 点赞或者取消赞
  COMMENT_INTERACTION = 58, // 评论交互 复制或回复
  FOLLOW_OR_NOT = 59, // 关注/取关
  COMMENT_REPLY_LIST = 60, // 评论详情/评论的回复列表
}
